import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Icon } from '../../atoms/icons';
import { colors } from '../../styles';

export interface Props {
  className?: string;
  sortAscending?: boolean;
  active?: boolean;
}

class SortCaret extends React.Component<Props, {}> {
  public render() {
    const { className, sortAscending } = this.props;
    return (
      <Icon
        icon="arrowDropdown"
        className={`${className} arrow ${sortAscending ? 'up' : 'down'}`}
        baseColor={colors.black}
        size="xs"
      />
    );
  }
}

export default styled(SortCaret)`
  &.up {
    transform: rotate(180deg);
  }
  margin-left: 0.25rem;
  height: 60px;
  right: 0;
  opacity: ${(props: Props) => (props.active ? 1 : 0)};
`;
